<template>
  <div>
    <table v-if="depAccount" class="table table-striped">
      <tbody>
        <tr>
          <th scope="row">Avtalt depositum</th>
          <td>
            <hl-Currency :amount="depAccount.amount"></hl-Currency>
          </td>
        </tr>
        <tr>
          <th scope="row">Sum frigjort til leietaker</th>
          <td>
            <hl-Currency :amount="tenantAmount"></hl-Currency>
          </td>
        </tr>
        <tr>
          <th scope="row">Sum ønsket frigjort til utleier</th>
          <td>
            <hl-Currency :amount="landlordAmount"></hl-Currency>
          </td>
        </tr>
        <tr>
          <th scope="row">Oppsigelse bekreftes av</th>
          <td>
            <p>{{ landlordFullName }}</p>
            <p>
              (Født:
              <hl-Date :date="landlordDateOfBirth"></hl-Date>)
            </p>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mt-4">
      <button class="btn btn-primary" type="button" :disabled="loading.post" @click="releaseDepAccount">
        <span v-if="loading.post" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
        <span v-if="loading.post" class="sr-only">Venter...</span>
        <span v-if="loading.post">Vennligst vent</span>
        <span v-else>Bekreft</span>
      </button>
      <router-link :to="{ name: 'tenancy_deposit' }" tag="button" class="btn btn-secondary ml-2">Avbryt</router-link>
    </div>

    <div v-if="errors">
      <hl-Alert v-for="(error, i) in errors" :key="i" variant="danger my-4">{{ error.message }}</hl-Alert>
    </div>

    <p class="mt-4 text-secondary text-small">
      Ved p trykke på knappen over bekrefter du at du har rett til å frigjøre depositumet som utleier, eller på vegne av
      utleier. Husleie.no AS tar ikke ansvar for depositum som blir frigjort ved en feil.
    </p>
  </div>
</template>

<script>
import { IdentificationApi, ProductApi } from '@modules/husleieapi2';
import { mapGetters, mapActions } from 'vuex';
import Currency from '@modules/husleie-framework/src/components/currency/Currency.vue';
import Date from '@modules/husleie-framework/src/components/time/Date.vue';
import Alert from '@modules/husleie-framework/src/components/text/Alert.vue';

export default {
  components: {
    'hl-Currency': Currency,
    'hl-Date': Date,
    'hl-Alert': Alert,
  },

  props: ['landlordId', 'tenancyId', 'depId', 'sessionId'],

  data() {
    return {
      depAccount: null,
      errors: null,
      landlord: null,
      landlordFullName: null,
      landlordDateOfBirth: null,
      loading: {
        post: false,
      },
    };
  },

  computed: {
    ...mapGetters('tenancy', ['getTenancyDeposits', 'getTenancyDeposit']),

    isFullRelease() {
      if (this.depAccount == null || this.depAccount.meta.splitType == null) return;
      return this.depAccount.meta.splitType === 'fullRelease';
    },

    tenantAmount() {
      return this.isFullRelease ? this.depAccount.meta.funds : this.depAccount.meta.funds - this.landlordAmount;
    },

    landlordAmount() {
      return this.isFullRelease ? 0 : this.depAccount.meta.landlordSplitAmount;
    },
  },

  methods: {
    ...mapActions('tenancy', ['fetchTenancyDeposits']),

    async fetchDeposits() {
      try {
        const res = await this.fetchTenancyDeposits({
          landlordId: this.landlordId,
          tenancyId: this.tenancyId,
        });
        return res;
      } catch (error) {
        console.error(error);
        this.$toast('Kunne ikke hente depositum.', 'error');
      }
    },

    async releaseDepAccount() {
      this.loading.post = true;
      try {
        const api = new ProductApi();
        const data = {
          body: {
            amount: this.landlordAmount,
            identitySessionId: this.sessionId,
            type: this.depAccount.meta.splitType === 'splitRelease' ? 'split' : 'tenant',
          },
        };
        const res = await api.releaseDepositAccount(this.depId, data);
        this.loading.post = false;
        this.$router.push({
          name: 'tenancy_deposit',
          params: { landlordId: this.landlordId, tenancyId: this.tenancyId },
        });
        return res;
      } catch (error) {
        this.errors = error.response.data.errors;
        this.loading.post = false;
        console.error(error);
      }
    },
  },

  mounted() {
    const api = new IdentificationApi();
    api.getIdentificationSessionResult(this.sessionId).then(res => {
      (this.landlordFullName = res.name), (this.landlordDateOfBirth = res.dateOfBirth);
    });

    this.fetchDeposits().then(() => (this.depAccount = this.getTenancyDeposit(this.depId)));
  },
};
</script>
